import { defineStore } from 'pinia'

import axios from 'axios'

import { getAPIURL } from '@/config'

const API_URL = getAPIURL()

export const useNotificationsStore = defineStore({
    id: 'notifications',

    state: () => ({
        unreadNotifications: [],
        loading: false,
        error: null
    }),

    getters: {

    },
    
    actions: {
        async fetchUnreadNotifications() {
            this.loading = true
            try {
                const { data } = await axios.get(`${API_URL}/notifications/unread`,
                    { headers: {
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                    }}
                )
                // server already knows g.current_company from your middleware
                // replace the array wholesale (or diff it as you like):
                this.unreadNotifications = data
                .sort((a,b) => new Date(b.TimeStamp) - new Date(a.TimeStamp))
            }
            catch (error) {
                console.error('Error fetching notifications:', error)
                this.error = error
            }
            finally {
                this.loading = false
            }
        },

        async updateNotificationStatus(notificationId, newStatus) {
            try {
                await axios.put(`${API_URL}/notifications/${notificationId}/status`, {
                    status: newStatus
                }, {
                    headers: {
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                    }
                })
            
                // Optionally remove it from local state immediately
                this.unreadNotifications = this.unreadNotifications.filter(n => n.NotificationId !== notificationId)
            } catch (error) {
                console.error(`Failed to update notification ${notificationId} status to ${newStatus}:`, error)
                this.error = error
            }
        },

        async updateMultipleNotificationStatuses(notificationIds, newStatus) {
            try {
                await axios.put(`${API_URL}/notifications/batch/status`, {
                    notification_ids: notificationIds,
                    status: newStatus
                }, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                    }
                })
        
                // Immediately update local state
                this.unreadNotifications = this.unreadNotifications.filter(
                    n => !notificationIds.includes(n.NotificationId)
                )
            } catch (error) {
                console.error(`Failed to update multiple notifications to ${newStatus}:`, error)
                this.error = error
            }
        }
    }
})